import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Dependencies = lazy(() => import('../pages/dependencies/page'));
const Processes = lazy(() => import('../pages/processes/page'));
const Tasks = lazy(() => import('../pages/tasks/page'));
const Evidences = lazy(() => import('../pages/evidences/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const SetupAuth = lazy(() => import('../pages/setup-auth/page'));
const Users = lazy(() => import('../pages/users/page'));
const Ranking = lazy(() => import('../pages/ranking/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const Reports = lazy(() => import('../pages/reports/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminYears = lazy(() => import('../pages/admin-years/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <ProtectedRoute><Home /></ProtectedRoute>,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/setup-auth',
    element: <SetupAuth />,
  },
  {
    path: '/dependencies',
    element: <ProtectedRoute><Dependencies /></ProtectedRoute>,
  },
  {
    path: '/processes',
    element: <ProtectedRoute><Processes /></ProtectedRoute>,
  },
  {
    path: '/tasks',
    element: <ProtectedRoute><Tasks /></ProtectedRoute>,
  },
  {
    path: '/evidences',
    element: <ProtectedRoute><Evidences /></ProtectedRoute>,
  },
  {
    path: '/profile',
    element: <ProtectedRoute><Profile /></ProtectedRoute>,
  },
  {
    path: '/users',
    element: <ProtectedRoute><Users /></ProtectedRoute>,
  },
  {
    path: '/ranking',
    element: <ProtectedRoute><Ranking /></ProtectedRoute>,
  },
  {
    path: '/tracking',
    element: <ProtectedRoute><Tracking /></ProtectedRoute>,
  },
  {
    path: '/reports',
    element: <ProtectedRoute><Reports /></ProtectedRoute>,
  },
  {
    path: '/admin/years',
    element: <ProtectedRoute><AdminYears /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
